import React from 'react'
import getPerformancesIntervall from '../func/getPerformanceIntervall'
import FlyerMovie from '../presents/FlyerMovie'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { FEATURES, PROGRAM_ATTRIBUTES, TRANSLATION } from '../../../constants/state'
import getData from '../../../functions/getData'
import { connect } from 'react-redux'
import filterPerformancesByCinemaId from '../func/filterPerformancesByCinemaId'

const sortAlphabetical = (attributes) => attributes.sort(function(a, b) {
    return b > a ? -1 : b < a ? 1 : 0
})

const mapStateToProps = (state, ownProps) => ({
    features: getData(state, FEATURES),
    allAttributes: getData(state, PROGRAM_ATTRIBUTES),
    translation: getData(state, TRANSLATION)
})

const FlyerMovieContainer = ({
    movies,
    itemData,
    movieTimesDesktop, 
    colors, 
    iconsColor,
    hideTheatres,
    performances, 
    translation,
    currentCinemaId,
    cinemaData, 
    week, 
    currentPeriodeStartDate, 
    currentPeriodeEndDate,
    allAttributes,
    features,
}) => {

    if(!movies || !itemData) {
        return ''
    }

    const { movieId, style, description } = itemData
    const movieData = movies[movieId]

    if(!movieData) {
        return ''
    }

    const moviePerf = filterPerformancesByCinemaId(movieData.performances, performances, currentCinemaId)
    const periodesDays = getPerformancesIntervall(moviePerf, week, currentPeriodeStartDate, currentPeriodeEndDate)
    const attributes = allAttributes[cinemaData.pk] ? allAttributes[cinemaData.pk] : null
    const sortedAttributes = attributes ? sortAlphabetical(_.keys(attributes.technical)) : null
    const hasFlyerCaptions = features.has_flyer_caption
    const captionAttributes = {}
    const technologyAttributes = []
    
    attributes && sortedAttributes && sortedAttributes.map((attributeId, index) => {
        const currentAlphabetNumber = (index + 10).toString(36).toUpperCase()
        const {name, movies} = attributes.technical[attributeId]    
        
        if(name !== 'blocksubscriptions') {
            captionAttributes[attributeId] = {
                captionLetter: currentAlphabetNumber,
                captionName: name,
                id: attributeId
            }
        }
        
        if(_.contains(movies, movieId)) {
            technologyAttributes.push({
                id: attributeId,
                name: name
            })
        }
    })
    
    return <FlyerMovie
        style={style}
        description={description}
        currentCinemaId={currentCinemaId}
        cinemaData={cinemaData}
        captionAttributes={captionAttributes}
        hasFlyerCaptions={hasFlyerCaptions}
        week={week}
        colors={colors}
        iconsColor={iconsColor}
        hideTheatres={hideTheatres}
        translation={translation}
        movieData={{
            ... movieData,
            performances: moviePerf,
            technologyAttributes: technologyAttributes 
        }}
        movieTimesDesktop={movieTimesDesktop}
        periodesDays={periodesDays}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(FlyerMovieContainer)